import type { ModalBodyProps } from './types';

import styled from 'styled-components';

export const StyledBody = styled.div<ModalBodyProps>`
  padding: ${props => props.padding || '0 26px'};
  margin-bottom: ${props => props.marginBottom || '42px'};
  height: ${props => props.height || 'auto'};
`;

/**
 * @deprecated
 */
const ModalBody = ({ className, children, ...rest }: ModalBodyProps & { children?: React.ReactNode }) => {
  return (
    <StyledBody className={className} {...rest}>
      {children}
    </StyledBody>
  );
};

export default ModalBody;
